import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import Coursecontentlist from '../components/courseContent/Coursecontentlist'
import Contact from '../components/Contact/Contact'

const ContactPage = () => {
  return (
    <>
    <Navbar/>
    <Contact/>
    </>

  )
}

export default ContactPage